import {isMobile, isTouch} from '@/utils/features';
import MixinMaintenanceMode from '@/mixins/MixinMaintenanceMode'

export const GenericMixin = {
  mixins: [
    MixinMaintenanceMode,
  ],
  props: {

  },
  data() {
		return {
			isTouch,
		};
  },
  computed: {
	},
  mounted() {

	},
  methods: {
		isMobile() {
			return isMobile();
		},
  }
};

export default GenericMixin;
